import { AsyncPipe } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatIconButton } from '@angular/material/button'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { MatTab, MatTabContent, MatTabGroup } from '@angular/material/tabs'
import { MatToolbar } from '@angular/material/toolbar'
import {
  ElderAuditedEntityComponent,
  ElderBasicPaneLayoutComponent,
  ElderDimensionsInputComponent,
  ElderHeaderComponent,
  ElderPaneActionsComponent,
  ElderPaneComponent,
  ElderPaneContentComponent,
  ElderPaneHeaderComponent,
  ElderPaneTitleComponent,
  ElderQuantityInputControlComponent,
  ElderThemeDirective,
  ElderToastService,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { BehaviorSubject } from 'rxjs'
import { PackageBrowserComponent } from '../../packages/package-browser/package-browser.component'
import { PackageGroupTableComponent } from '../package-group-table/package-group-table.component'
import { StorageGroup } from '../storage-group'

@Component({
  selector: 'app-storage-group-detail',
  templateUrl: './storage-group-detail.component.html',
  styleUrls: ['./storage-group-detail.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatIcon,
    ElderHeaderComponent,
    MatTabGroup,
    MatTab,
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    ElderQuantityInputControlComponent,
    ElderDimensionsInputComponent,
    ElderAuditedEntityComponent,
    PackageGroupTableComponent,
    MatTabContent,
    PackageBrowserComponent,
    AsyncPipe,
    ElderTranslatePipe,
    ElderBasicPaneLayoutComponent,
    ElderPaneComponent,
    ElderPaneContentComponent,
    ElderPaneHeaderComponent,
    ElderPaneActionsComponent,
    ElderPaneTitleComponent,
  ],
})
export class StorageGroupDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly storageGroup$ = new BehaviorSubject<StorageGroup>(null)

  private toastService = inject(ElderToastService)

  @Input()
  public set storageGroup(storageGroup: StorageGroup) {
    if (!storageGroup) {
      return
    }
    this.storageGroup$.next(storageGroup)
  }

  public get storageGroup(): StorageGroup {
    return this.storageGroup$.getValue()
  }

  @Output()
  public close: EventEmitter<void> = new EventEmitter()

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public save(): void {
    this.toastService.info('Not yet implemented')
  }

  public doClose(event: Event): void {
    this.close.emit()
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
